import React, {useContext} from 'react'

export type ReportsTableRowContextProps = {
  item: any
}

const ReportsTableRowContext = React.createContext<ReportsTableRowContextProps>(null as any)

export default ReportsTableRowContext

export function useReportsTableRowContext() {
  return useContext(ReportsTableRowContext)
}
